import withMyPerformanceData from "./withMyPerformanceData";
import MyPerformance from "./MyPerformance";

export default withMyPerformanceData(MyPerformance);
